module.exports = "<div class=\"container\">\n  <div>\n    <h1 style=\"text-align: center;\">{{DConfirmCtrl.message}}</h1>\n  </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./client/app/devices/confirm/confirm.html
// module id = 342
// module chunks = 0